import { createSlice } from '@reduxjs/toolkit';
import {
  deleteJournal,
  getJournalByDate,
  getJournals,
  saveJournal,
} from './journalsActions';

const initialState = {
  loading: false,
  journals: [],
  journal: null,
  error: null,
  success: false,
};

const journalsSlice = createSlice({
  name: 'journals',
  initialState,
  reducers: {},
  extraReducers: {
    // get journals
    [getJournals.pending]: state => {
      state.loading = true;
    },
    [getJournals.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.journals = payload.data;
    },
    [getJournals.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // get journal by date
    [getJournalByDate.pending]: state => {
      state.loading = true;
    },
    [getJournalByDate.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.journal = payload.data;
    },
    [getJournalByDate.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // save journal
    [saveJournal.pending]: state => {
      state.loading = true;
    },
    [saveJournal.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.journal = payload.data;
    },
    [saveJournal.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // delete journal
    [deleteJournal.pending]: state => {
      // state.loading = true;
    },
    [deleteJournal.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [deleteJournal.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export default journalsSlice.reducer;
